import request from '@/utils/request'
let _speedOption

export default {
  // 取得 speed 計算頁所有選項
  getSpeedOptions () {
    if (!_speedOption) {
      return request.get('/api/v1/qp/conditions/options').then(result => {
        _speedOption = result
        return Promise.resolve(result)
      })
    } else {
      return Promise.resolve(_speedOption)
    }
  },
  // 取得 direct 計算頁所有選項
  getDirectOptions () {
    return request.get('/api/v1/qp/conditions/direct_options')
  },
  // 取得客戶列表
  getClientListData () {
    return request.get('/api/v1/qp/infos/qp_client_list')
  },
  // 取得代理商列表
  getAgencyListData () {
    return request.get('/api/v1/qp/infos/qp_agency_list')
  },
  // 送出計算執行組合
  createQuickPlanInfo (params) {
    return request.post('/api/v1/qp/infos', params)
  },
  // 執行計算
  doCalculation (id) {
    return request.post('/api/v1/qp/sim_results/data', { qp_condition_id: id })
  },
  // 取得目的導引流程的建議計算結果
  getPlanningResult (params) {
    return request.post('/api/v1/qp/sim_results/plan_data', params)
  },
  // 取得受眾導引流程的建議計算結果
  getProfilingResult (params) {
    return request.post('/api/v1/qp/sim_results/profile_data', params)
  },
  recentInputs () {
    return request.get('/api/v1/qp/infos/recent_infos')
  }
}
